module.exports = __webpack_public_path__ + "img/1-(3).546b51a1.jpg";